import { useMemo } from 'react';

export const useDrawButtonLabels = (
  buttonLocation: string,
  isPreOrder: boolean,
  isMobile = false,
) => {
  const key = isPreOrder ? 'preOrder' : 'draw';

  return useMemo(() => {
    if (buttonLocation === 'dialogCta') {
      return {
        normal: `subscriptionCta.${key}.learnMoreDialog.buttonTitle`,
        success: `subscriptionCta.${key}.buttonSuccessTitle`,
      };
    }

    if (buttonLocation === 'stickyCta') {
      return {
        normal:
          isMobile && isPreOrder
            ? `subscriptionCta.${key}.stickyHeader.buttonTitleMobile`
            : `subscriptionCta.${key}.stickyHeader.buttonTitle`,
        success: `subscriptionCta.${key}.stickyHeader.buttonSuccessTitle`,
      };
    }

    return {
      normal: `subscriptionCta.${key}.buttonTitle`,
      success: `subscriptionCta.${key}.buttonSuccessTitle`,
    };
  }, [buttonLocation, isMobile, isPreOrder, key]);
};
